import {Injectable} from '@angular/core';
import {DeviceService} from '@webmate-web-core/shared/services/device/device.service';
import {DeviceId, ExpeditionId, ProjectId} from '@webmate-web-core/shared/types/ids';
import {Observable, Subject} from 'rxjs';
import {filter, map, mergeMap, take} from 'rxjs/operators';
import {BrowserSessionService} from '@webmate-web-core/shared/services/browsersession.service';
import {WorkbenchLayoutManager} from './workbench-layout-manager.service';
import {ConsolePlugin} from '../../workbench-plugins/console/console-plugin';
import {WorkbenchConsoleEvent} from '../../workbench-plugins/console/consoles/workbench-console';
import {DevicePropertyNames} from '@webmate-web-core/shared/types/devices/device-properties';

@Injectable()
export class WorkbenchConsoleService {

    // some business rules:
    // - an expedition can only run on a tracked device
    // - when the device vanishes, its associated expeditions must not be made available any longer
    // - only running expeditions are being tracked

    constructor(private layoutManager: WorkbenchLayoutManager,
                private deviceService: DeviceService, private expeditionService: BrowserSessionService) {
    }

    private consoleEventSubject: Subject<WorkbenchConsoleEvent> = new Subject<WorkbenchConsoleEvent>();
    public getWorkbenchConsoleEvent$(deviceId: DeviceId): Observable<WorkbenchConsoleEvent>{
        return this.consoleEventSubject.pipe(filter(e => e.targetDevice === deviceId));
    }
    public raiseWorkbenchConsoleEvent(event: WorkbenchConsoleEvent){
        this.consoleEventSubject.next(event);
    }

    openConsoleForExpedition(id: ExpeditionId): Observable<any> {
        return this.expeditionService.getBrowserSessionInfo$(id).pipe(
            filter(sessionInfo => {
                return sessionInfo.isActive() && !!sessionInfo.optDeviceId
            }),
            take(1),
            mergeMap(sessionInfo => {
                return this.openConsoleForDevice(sessionInfo.optDeviceId!);
            }),
            take(1)
        );
    }

    private openConsoleForDevice(deviceId: DeviceId): Observable<any> {
        return this.deviceService.getDevice$(deviceId).pipe(
            take(1),
            map(device => {
                this.layoutManager.instantiateAndShowViewTemplate(ConsolePlugin.ViewTemplateId, {id: device.id, name: device.name, additionalStartupProperties: [DevicePropertyNames.SeleniumNode]});
            })
        )
    }

}
